import matter from "gray-matter";

const imagesContext = require.context("../images", false, /\.(png|jpe?g|gif|svg)$/);
const imagesMap = imagesContext.keys().reduce((acc, key) => {
  const filename = key.replace("./", "");
  acc[filename] = imagesContext(key);
  return acc;
}, {});

async function parseMarkdown(text, fallbackSlug) {
  const { data, content } = matter(text);

  const slug = (data.slug || fallbackSlug).replace(/\s+/g, "-").toLowerCase();
  const title = data.title || fallbackSlug;
  const date = data.date
    ? (typeof data.date === "string" ? data.date : new Date(data.date).toISOString().slice(0, 10))
    : new Date().toISOString().slice(0, 10);
  const author = data.author || "Pratidhi Therapy & Wellness";
  const tags = Array.isArray(data.tags) ? data.tags : (data.tags ? [data.tags] : []);
  const description = data.description || (content.split(/\n\n+/)[0] || "").replace(/\n/g, " ");
  const cover = data.cover && (imagesMap[data.cover] || data.cover);

  return { slug, title, date, author, tags, description, excerpt: description, cover, content };
}

let _cachedPosts = null;

export async function getAllBlogs() {
  if (_cachedPosts) return _cachedPosts;

  const indexRes = await fetch("/blog/index.json");
  const filenames = await indexRes.json();

  const posts = await Promise.all(
    filenames.map(async (filename) => {
      const res = await fetch(`/blog/${filename}`);
      const text = await res.text();
      const fallbackSlug = filename.replace(/\.md$/, "");
      return parseMarkdown(text, fallbackSlug);
    })
  );

  _cachedPosts = posts.sort((a, b) => new Date(b.date) - new Date(a.date));
  return _cachedPosts;
}

export async function getBlogBySlug(slug) {
  const posts = await getAllBlogs();
  return posts.find((p) => p.slug === slug);
}

export async function getAllTags() {
  const posts = await getAllBlogs();
  const set = new Set();
  posts.forEach((p) => p.tags.forEach((t) => set.add(t.trim())));
  return Array.from(set).sort();
}

export async function getPostsByTag(tag) {
  const posts = await getAllBlogs();
  if (!tag) return posts;
  return posts.filter((p) => p.tags.includes(tag));
}

export function resolveImageSrc(name) {
  return imagesMap[name] || name;
}
